import { AvatarCustom, Loading } from "../../../components";
import React, { useEffect, useState } from "react";

import { EditPetProfileForm } from "../../forms";
import GvUploadImageButton from "../../../components/GvUploadImageButton/GvUploadImageButton";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { PetUpdateFormType } from "../../../services/pet-update/pet-update.schema";
import { usePageTitleContext } from "../../../context/PageTitleContext";
import { usePetDetail } from "../../../services/pet-detail/pet-detail.service";
import { usePetUpdate } from "../../../services/pet-update/pet-update.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { userActivityLogger } from "../../../utils/mixpanel";
import { Typography, Box } from "@mui/material";
import { CustomToolTip } from "../EditHospitalContainer/EditHospitalContainer.style";

const PetEditProfileContainer = () => {
  const { setPageTitle } = usePageTitleContext();
  const navigate = useNavigate();
  const [fileImage, setFileImage] = useState<File>();

  const [searchParams] = useSearchParams();
  const petId = searchParams.get("id");
  // eslint-disable-next-line no-unused-vars
  const { petUpdate, petUpdated, error: updateError } = usePetUpdate();
  const { getPetInfo, loading, pet } = usePetDetail();
  // const theme = useTheme();
  // const mobileSize = useMediaQuery(theme.breakpoints.down("sm"));

  const onChangeUploadImage = (file: File) => {
    setFileImage(file);
  };

  const handleSubmit = (dataForm: PetUpdateFormType) => {
    userActivityLogger(MIXPANEL_EVENTS.EDIT_PET_CLICK, {
      pet_name: pet?.pet.name,
    });
    petUpdate(petId as string, dataForm, fileImage as File);
  };

  useEffect(() => {
    if (petId) {
      getPetInfo(petId);
    }
  }, [petId]);


  useEffect(()=>{
    if (pet) {
      setPageTitle(`Edit ${pet?.pet.name}'s Profile`);
      userActivityLogger(MIXPANEL_EVENTS.EDIT_PET_PAGE, { pet_name: pet?.pet.name });
    }
  }, [pet]);

  useEffect(()=>{
    if (petUpdated) {
      userActivityLogger(MIXPANEL_EVENTS.EDIT_PET_SUCCESS, { pet_name: petUpdated?.updatePetV2.pet.name });
      navigate(-1);
    }
    if (updateError) {
      userActivityLogger(MIXPANEL_EVENTS.EDIT_PET_FAILURE,
        { pet_name: petUpdated?.updatePetV2.pet.name, failure_reason: updateError.graphQLErrors[0].message });
    }
  }, [petUpdated, updateError]);

  if (loading || !petId) {
    return <Loading />;
  }


  return (
    <>
      <div className="flex justify-center w-full">
        <div className="w-full max-w-[34rem] flex flex-col gap-4">
          <div className="flex justify-center">
            <div className="relative">
              <GvUploadImageButton
                id="EditPetPhoto"
                icon={<AvatarCustom
                  name={pet?.pet.name}
                  width={100}
                  height={100}
                  avatarStyleToggle={true}
                />}
                url={pet?.pet.image || ""}
                hideUploadButton={true}
                onChange={onChangeUploadImage}
                aspect={1}
              />
              {!pet?.pet.image &&
              <div className="absolute top-0 right-0">
                <CustomToolTip
                  title={
                    <Typography color="inherit">
                                Add{` ${pet?.pet.name}'s`}  profile picture.
                    </Typography>
                  }
                  placement="top"
                  sx={{ marginLeft: "1rem !important" }}
                >
                  <Box className="cursor-pointer">
                    <img src="/assets/icons/Notification bubble.svg" className="!w-4 !h-4 mt-2" alt={"info"}/>
                  </Box>
                </CustomToolTip>
              </div>}
            </div>
          </div>
          <EditPetProfileForm
            onSubmit={handleSubmit}
            pet={pet?.pet}
          />
        </div>
      </div>
    </>
  );
};

export default PetEditProfileContainer;
